<template>
  <div v-if="isActive">
    <div class="impersonation-frame" />
    <div class="impersonation-pill">
      <span class="pill-info">
        <span class="pill-dot" />
        Personificando <b>{{ displayName }}</b>
        <span
          class="pill-timer"
          title="Tempo de acesso">· {{ formattedElapsed }}</span>
      </span>
      <button
        class="pill-button"
        :disabled="stopping"
        @click="end">Encerrar</button>
    </div>
    <impersonation-confirm-modal
      :open="confirming"
      title="Encerrar sessão de personificação?"
      cancel-label="Continuar personificando"
      confirm-label="Encerrar agora"
      loading-label="Encerrando..."
      :loading="stopping"
      @cancel="cancelEnd"
      @confirm="runStop">
      O acesso à conta de <b>{{ displayName }}</b> será cortado na hora — o token expira e você volta pra sua conta de suporte. A sessão fica registrada para auditoria.
    </impersonation-confirm-modal>
  </div>
</template>

<script>
import ImpersonationConfirmModal from './ImpersonationConfirmModal.vue'

export default {
  name: 'ImpersonationBar',
  components: { ImpersonationConfirmModal },
  data: () => ({
    elapsed: 0,
    stopping: false,
    confirming: false,
    intervalId: null
  }),
  computed: {
    impersonation () {
      return this.$store.state.auth.impersonation
    },
    isActive () {
      return this.impersonation !== null && this.impersonation.active === true
    },
    displayName () {
      if (this.isActive === false) return ''
      const client = this.impersonation.client
      if (client.name === null || client.name === '') return client.email
      return client.name
    },
    formattedElapsed () {
      const hours = Math.floor(this.elapsed / 3600)
      const minutes = Math.floor((this.elapsed % 3600) / 60)
      const seconds = this.elapsed % 60
      return [hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(':')
    }
  },
  watch: {
    isActive (active) {
      if (active === true) this.startTimer()
      else this.stopTimer()
    }
  },
  mounted () {
    if (this.isActive === true) this.startTimer()
  },
  beforeDestroy () {
    this.stopTimer()
  },
  methods: {
    startTimer () {
      this.tick()
      this.intervalId = setInterval(this.tick, 1000)
    },
    stopTimer () {
      if (this.intervalId !== null) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    },
    tick () {
      if (Date.now() >= new Date(this.impersonation.expiratedAt).getTime()) {
        this.runStop()
        return
      }
      this.elapsed = Math.floor((Date.now() - this.impersonation.startedAt) / 1000)
    },
    end () {
      this.confirming = true
    },
    cancelEnd () {
      if (this.stopping === true) return
      this.confirming = false
    },
    runStop () {
      if (this.stopping === true) return
      this.stopping = true
      this.$store.dispatch('auth/stopImpersonation').finally(() => {
        this.stopping = false
        this.confirming = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.impersonation-frame {
  position: fixed;
  inset: 0;
  border: 3px solid #7c3aed;
  pointer-events: none;
  z-index: 1030;
}

.impersonation-pill {
  position: fixed;
  left: 50%;
  top: 4px;
  transform: translateX(-50%);
  background: #241b3a;
  color: #fff;
  border-radius: 999px;
  padding: 10px 12px 10px 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: 0 16px 40px rgba(76, 29, 149, 0.4);
  z-index: 1031;
}

.pill-info {
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 13.5px;
}
.pill-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #a78bfa;
  box-shadow: 0 0 0 4px rgba(167, 139, 250, 0.3);
}
.pill-timer {
  color: #b9a9e6;
  font-variant-numeric: tabular-nums;
}

.pill-button {
  background: #7c3aed;
  color: #fff;
  border: 0;
  border-radius: 999px;
  height: 32px;
  padding: 0 16px;
  font-weight: 700;
  font-size: 12.5px;
  cursor: pointer;
  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Support/ImpersonationBar.vue